export default [{
  name: 'addMap',
  path: '/addMap',
  component: () => import('./AddMap.vue'),
  meta: {
    title: '地图测试'
  }
}]



// WEBPACK FOOTER //
// ./src/router/map/index.js